export default __webpack_public_path__ + "static/media/item3.7ce8dab2.jpg";